export const triggerAnalytics = (payload) => window?.LIFE_CYCLE_EVENT_BUS?.trigger?.('questions-and-answers.click',
  payload);